import React, { useState } from 'react';
import { AccordionItemHeading, AccordionItemButton } from 'react-accessible-accordion';
import Actions from './props/Actions';
import { AttachmentList } from '../../../components/Attachments';

const Email = (props) => {
    let { activity, activityData, onUpdateActivity } = props;
    let [hovered, setHovered] = useState(false);

    const getStatusBackgroundColor = (status) => {
        const colors = {
            'completed': '#F0FDF4',
            'pending': '#FFF6F2',
            'cancelled': '#FFF2F2',
            'in-progress': '#EFF6FF'
        };
        return colors[status] || '#6c757d';
    };

    const getStatusColor = (status) => {
        const colors = {
            'completed': '#16A34A',
            'pending': '#EA580C',
            'cancelled': '#EA580C',
            'in-progress': '#2563EB'
        };
        return colors[status] || '#6c757d';
    };

    const getPriorityBackgroundColor = (priority) => {
        const colors = {
            'urgent': '#FFF2F2',
            'high': '#FFF6F2',
            'medium': '#EFF6FF',
            'low': '#6c757d'
        };
        return colors[priority] || '#6c757d';
    };
    const getPriorityColor = (priority) => {
        const colors = {
            'urgent': '#EF4D56',
            'high': '#EA580C',
            'medium': '#2563EB',
            'low': '#6c757d'
        };
        return colors[priority] || '#6c757d';
    };

    return (
        <>
            <AccordionItemHeading>
                <AccordionItemButton>
                    <div className="activity-card email-card">
                        <div className="activity-header">
                            <div className="activity-type-info">
                                <div className="activity-icon email-icon">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div className="activity-details">
                                    <div className="activity-title">
                                        <span className="activity-type-label">Email</span>
                                        <span className="activity-subject">
                                            {activity?.emailSubject || activity?.title || 'Email sent'}
                                        </span>
                                    </div>
                                    <div className="activity-meta">
                                        <span className="created-by">by {activityData?.createdBy}</span>
                                        {activity?.metadata?.recipient && (
                                            <span className="recipient">to {activity.metadata.recipient}</span>
                                        )}

                                        <div className="activity-badges">
                                            <span
                                                className="status-badge"
                                                style={{ backgroundColor: getStatusBackgroundColor(activity?.status), color: getStatusColor(activity?.status) }}
                                            >
                                                {activity?.status || 'completed'}
                                            </span>
                                            <span
                                                className="priority-badge"
                                                style={{ backgroundColor: getPriorityBackgroundColor(activity?.priority), color: getPriorityColor(activity?.status) }}
                                            >
                                                {activity?.priority || 'medium'}
                                            </span>
                                            {activity?.metadata?.source && (
                                                <span
                                                    className="source-badge"
                                                    style={{
                                                        backgroundColor: activity.metadata.source === 'manual' ? '#6c757d' : '#007bff',
                                                        color: '#fff',
                                                        padding: '2px 8px',
                                                        borderRadius: '12px',
                                                        fontSize: '11px',
                                                        fontWeight: '500'
                                                    }}
                                                >
                                                    {activity.metadata.source === 'manual' ? 'Manual' : 'Workflow'}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div className="activity-actions" onClick={(e) => e.stopPropagation()}>
                                <Actions {...props} />
                                <span className="activity-time">{activityData?.createdAt}</span>
                            </div>
                        </div>

                        {activity?.description && (
                            <div className="activity-description">
                                <p dangerouslySetInnerHTML={{ __html: activity.description }}></p>
                            </div>
                        )}

                        {activity?.metadata && (
                            <div className="activity-metadata">
                                {activity.metadata.messageId && (
                                    <div className="metadata-item">
                                        <strong>Message ID:</strong> {activity.metadata.messageId}
                                    </div>
                                )}
                                {activity.metadata.workflowId && (
                                    <div className="metadata-item">
                                        <strong>Via Workflow</strong>
                                        <span className="workflow-badge">Automated</span>
                                    </div>
                                )}
                            </div>
                        )}
                        
                        {/* Attachments Section */}
                        {activity['attachments'] && activity['attachments'].length > 0 && (
                            <div className="activity-attachments" style={{ marginTop: '10px' }}>
                                <AttachmentList 
                                    attachments={activity['attachments']} 
                                    showUploadedBy={false}
                                    enableActions={false}
                                />
                            </div>
                        )}
                    </div>
                </AccordionItemButton>
            </AccordionItemHeading>
        </>
    );
};

export default Email;